<template>
  <v-card dark class="elevation-10">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="detail"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td @click="viewpayment(item.PaymentId)" class="text-left">
              {{ item.Payment.localId }}
              <v-chip v-if="item.stripeChargeId" color="yellow" light small class="ml-2">Online</v-chip>
              <v-chip v-if="item.donation" color="pink" small class="ml-2">Donation</v-chip>
            </td>

            <td class="text-left">
              {{ item.AdvancePayment.Customer.name }}
              
            </td>

            <td @click="viewpayment(item.PaymentId)" class="text-left">
              {{ item.amount | currency }}
              <div v-if="item.referenceNumber">{{ item.referenceNumber }}</div>
            </td>

            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="viewpayment(item.PaymentId)">
                    <v-list-item-title>View Payment</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import advancePaymentService from "../service";
export default {
  props: {
    AdvancePaymentId: {
      default: null,
    },
  },
  name: "advance-payment-detail-list",
  data() {
    return {
      loading: true,
      headers: [
        {
          text: "Payment Number",
          align: "left",
          value: "Payment.localId",
          sortable: true,
        },
        {
          text: "Customer Name",
          align: "left",
          value: "AdvancePayment.Customer.name",
          sortable: true,
        },
        {
          text: "Amount",
          align: "left",
          value: "amount",
          sortable: true,
        },

        {
          text: "",
          value: "action",
          sortable: false,
          width: "20px",
        },
      ],
      detail: [],
      page: 1,
      sortBy: "Payment.localId",
      itemsPerPage: 10,
    };
  },
  created() {
    this.$events.listen("advancePaymentDetailListEvent", () => this.getList());
    this.getList();
  },
  beforeDestroy() {
    this.$events.remove("advancePaymentDetailListEvent");
  },
  methods: {
    viewpayment(paymentId) {
      const routeData = this.$router.resolve({
        path: `/global/payment/${paymentId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    getList() {
      return advancePaymentService
        .getDetailById(this.AdvancePaymentId)
        .then((response) => {
          this.detail = response.data;
          this.loading = false;
          return response;
        });
    },
  },
};
</script>
